import React, { Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import styled from "styled-components";
import { Grid, Divider } from "@material-ui/core";
import loanTypes from "constants/loanTypes";

import GridTextArea from "../Components/GridTextArea";
import SectionTitle from "../Components/SectionTitle";

const SpacerDiv = styled.div`
  height: 800px;
`;

class Other extends React.Component {
  render() {
    const {
      loan,
      handleChange,
      handleTextChange,
      isNewLoan,
      isEditing,
      isInitialized
    } = this.props;

    return (
      <span id="loan_other">
        <Grid hidden={!isInitialized} item xs={7}>
          <SectionTitle>Other</SectionTitle>
        </Grid>
        <Grid container item xs={12}>
          <GridTextArea
            name="other"
            label="Other"
            value={loan.other}
            multiline
            onChange={handleTextChange}
            isEditing={isEditing}
            shouldShow={isInitialized}
          />
        </Grid>
        <Grid hidden={!isInitialized} item xs={12}>
          <SpacerDiv />
        </Grid>
      </span>
    );
  }
}

const mapStateToProps = state => {
  const { loading } = state;

  return {
    loading
  };
};

export default compose(
  connect(
    mapStateToProps,
    {

    }
  )
)(Other);
